module.exports = __webpack_public_path__ + "img/perilfinder.b4de0615.svg";